export const insertTransactionMutation = (builder) => ({
  insertTransaction: builder.mutation({
    query: (credentials) => {
      const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';

      return {
        url: '/insert_transaction',
        method: 'POST',
        body: credentials,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token 
        },
      };
    },
  }),
});